import { useState } from 'react';
import { headerNavItems } from '@/config/navigation';
import { siteConfig } from '@/config/site';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black/90 backdrop-blur-sm border-b border-gray-800">
      <div className="page-container">
        <div className="flex items-center justify-between h-14 sm:h-16 lg:h-20">
          <div className="flex-shrink-0">
            <a href="#home" className="flex items-center">
              <img
                src={siteConfig.logo.white}
                alt={`${siteConfig.name} Logo`}
                className="h-8 w-auto sm:h-10 lg:h-12"
              />
            </a>
          </div>

          <nav className="hidden lg:flex items-center gap-6 xl:gap-8">
            {headerNavItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                className={`relative text-sm font-medium transition-colors duration-300 hover:text-orange-500 whitespace-nowrap ${
                  item.isSpecial
                    ? 'text-orange-500 after:content-["new"] after:absolute after:-top-2 after:-right-6 after:text-xs after:bg-orange-500 after:text-black after:px-1 after:rounded after:font-bold'
                    : 'text-white'
                }`}
              >
                {item.label}
              </a>
            ))}
          </nav>

          <button
            type="button"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden flex flex-col items-center justify-center w-9 h-9 -mr-1 cursor-pointer"
            aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={isMenuOpen}
          >
            <span className={`block w-5 h-0.5 bg-white transition-transform duration-300 ${isMenuOpen ? 'rotate-45 translate-y-1.5' : ''}`} />
            <span className={`block w-5 h-0.5 bg-white transition-opacity duration-300 ${isMenuOpen ? 'opacity-0' : ''}`} />
            <span className={`block w-5 h-0.5 bg-white transition-transform duration-300 ${isMenuOpen ? '-rotate-45 -translate-y-1.5' : ''}`} />
          </button>
        </div>

        {isMenuOpen && (
          <nav className="lg:hidden py-3 border-t border-gray-800 max-h-[calc(100dvh-3.5rem)] overflow-y-auto">
            <div className="flex flex-col gap-2.5 pb-2">
              {headerNavItems.map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  onClick={() => setIsMenuOpen(false)}
                  className={`py-1.5 text-sm font-medium transition-colors duration-300 hover:text-orange-500 ${
                    item.isSpecial ? 'text-orange-500' : 'text-white'
                  }`}
                >
                  {item.label}
                  {item.isSpecial && (
                    <span className="ml-2 text-xs bg-orange-500 text-black px-1 rounded font-bold">new</span>
                  )}
                </a>
              ))}
            </div>
          </nav>
        )}
      </div>
    </header>
  );
}
